module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/logo-small-dd0358090610d8c524cb423ac122f3ab.png";